const STREAM_ID = /^\d{1,16}-\d{1,16}$/;

const compareDigits = (a: string, b: string): number => {
    if (a.length !== b.length) return a.length < b.length ? -1 : 1;
    if (a === b) return 0;
    return a < b ? -1 : 1;
};

export const isStreamId = (value: unknown): value is string => typeof value === 'string' && STREAM_ID.test(value);

export const compareStreamId = (a: string, b: string): number => {
    const [aMs = '0', aSeq = '0'] = a.split('-');
    const [bMs = '0', bSeq = '0'] = b.split('-');
    return compareDigits(aMs.replace(/^0+(?=\d)/, ''), bMs.replace(/^0+(?=\d)/, '')) || compareDigits(aSeq.replace(/^0+(?=\d)/, ''), bSeq.replace(/^0+(?=\d)/, ''));
};
